import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/facturacion/abonos';
import Abonos from './AbonoClienteTabs';


const ms2p = (state) => {
  return {
    ...state.abono_cxc,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Abonos);
